'use client';

import type { CSSProperties, FC, PropsWithChildren } from 'react';
import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';

const MotionDiv = dynamic(
  async () => {
    const { motion } = await import('framer-motion');
    return function MotionWrapper(props: any) {
      return <motion.div {...props} />;
    };
  },
  { ssr: false }
);

const LazyWrapper: FC<PropsWithChildren<{ threshold?: number; styles?: CSSProperties }>> = ({
  children,
  threshold,
  styles
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: threshold ?? 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative', ...(styles ? styles : {}) }}>
      {visible && (
        <MotionDiv
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {children}
        </MotionDiv>
      )}
    </div>
  );
};

export default LazyWrapper;
